import React from "react";

export default function Spinner() {
	return <img src="./images/tail-spin.svg" />
}

